<template>
  <div class="toZhwydjpt">
    <!-- toZhwydjpt -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'toZhwydjpt',
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  created() {
    //智慧物业对接平台
    // let timeStamp = new Date().getTime();
    // if (process.env.NODE_ENV === 'development') {
    //   window.open(
    //     'http://192.168.100.177:9010/LoginManageExtendController/login_new?token=' +
    //       this.token +
    //       '&code=' +
    //       localStorage.getItem('code') +
    //       '&t=' +
    //       timeStamp
    //   );
    // } else if (process.env.NODE_ENV === 'production') {
    //   window.open(
    //     'https://zjj.sz.gov.cn/szwyfwpt/kfpt/LoginManageExtendController.assx/login_new?token=' +
    //       this.token +
    //       '&code=' +
    //       localStorage.getItem('code') +
    //       '&t=' +
    //       timeStamp
    //   );
    // }

    // this.$router.go(-1);
  },
};
</script>

<style></style>
